// noinspection JSUnusedLocalSymbols
const text = require('./text.yaml')[templateVars.lang];

class CStockMarketBase {
	constructor() {}
	init() {
		if ($('[data-carousel-control]').length === 0) {
			return;
		}

		$('[data-carousel-control] .key__nav-item').click((e) => {
			e.preventDefault();
			const element = $(e.currentTarget);
			const parent = element.closest('[data-carousel-control]');
			parent.find('.key__nav-item').removeClass('__active');
			element.addClass('__active');
			const index = element.index();
			const left = '-' + (index * 100) + '%';
			$('[data-carousel-content="' + parent.data('carousel-control') + '"] .js-carousel-container').css({
				left: left
			});
		});
	}
}

AR.waitComponents(['cPreloader_base'], () => {
	const cStockMarketBase = new CStockMarketBase();
	cStockMarketBase.init();
	AR.pushComponent(cStockMarketBase, 'cStockMarket_base');
});



// WEBPACK FOOTER //
// ./temp/components/stock-market/.variant/base/index.js